export async function refreshSseTicketWithRecovery(targetUuid: string) {
  try {
    const { attemptAuthRecovery } = await import("@/dataProvider/axios");
    await attemptAuthRecovery();
  } catch {
    /* best-effort auth recovery only */
  }
  try {
    const { refreshSseTicket } = await import("../devAgentService");
    return await refreshSseTicket(targetUuid);
  } catch {
    return "";
  }
}
